import React from 'react';

interface ToasterProps {
  pushToastMessage: (message: ToastMessage) => void;
}

export const ToasterContext = React.createContext<ToasterProps>({
  pushToastMessage: () => undefined,
});
